<template>
  <div class="comments-section">
    <div class="CommentsBubble">
      <div class="comments-count-icon">
        <img src="../../assets/share/comment.svg" />
        <p v-if="commentsCount > 0" >{{ commentsCount }}</p>
      </div>
      <div>
        <p class="say-something">Write a comment...</p>
      </div>
    </div>

    <div class="emojies">
      <div>&#128513;</div>
      <div>&#128077;</div>
      <div>&#128514;</div>
      <div>&#128536;</div>
    </div>
  </div>
</template>




<script>
import { convertNumberToKiloNotation } from "../../../../helpers/formatters";


export default {
  name: "Comments",
  props: {
    commentsCount: {
      type: Number,
    },
  },
  computed: {
    commentsCountInKilo(){
      return convertNumberToKiloNotation(this.commentsCount);
    }
  }
};
</script>



<style scoped>
.say-something {
  margin-left: 0.5rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: 0.05rem;
  text-align: left;
  color: #fff;
}
.emojies div {
  margin: 0;
  padding: 0;
  font-size: 2rem;
}

.comments-count-icon p {
  font-size: 0.75rem;
  margin-left: 0.2rem;
}
.emojies {
  padding: 0;
  margin: 0;
  width: 40%;
  display: grid;
  grid-row-gap: 10px;
  grid-template-columns: auto auto auto auto;
}
p,
span {
  color: white;
  margin: 0em;
  padding: 0em;
}

/* flex */
.CommentsBubble {
  margin: 0;
  height: 2.5rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 40px;
  width: 60%; /* USE GRID INSTEAD OF PERCENTAGE */
  padding: 0 1rem 0 1rem;
  opacity: 0.95;
  border: solid 0.005rem #3a3438;
  background-color: rgba(0, 0, 0, 0.54);
}

.comments-count-icon {
  display: flex;
  flex-direction: row;
  align-items: center;
  
}
.comments-count-icon img{
  width:1.25rem !important;
}

.comments-section {
  gap: 0.5rem;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
}

@media only screen and (min-width: 50px) {
  .comments-count-icon img {
    width: 50%;
  }

  .say-something {
    font-size: 0.4rem;
  }
  .CommentsBubble {
    height: 2rem;
  }

  .emojies div {
    font-size: 1.2rem;
  }
}

@media only screen and (min-width: 300px) {
  .say-something {
    font-size: 0.55rem;
  }
  .CommentsBubble {
    height: 2rem;
  }
  .emojies div {
    font-size: 1.5rem;
  }
}

@media only screen and (min-width: 450px) {
  .say-something {
    font-size: 0.9rem;
  }
  .emojies div {
    font-size: 1.5rem;
  }
}

@media only screen and (min-width: 650px) {
  .say-something {
    font-size: 0.9rem;
  }

  .comments-count-icon p {
    font-size: 0.9rem;
    margin-left: 0.2rem;
  }
    .emojies div {
    font-size: 1.5rem;
  }
}

@media only screen and (min-width: 800px) {
  .say-something {
    font-size: 0.8rem;
  }

  .comments-count-icon p {
    font-size: 0.9rem;
    margin-left: 0.2rem;
  }
    .emojies div {
    font-size: 1.5rem;
  }
}

@media only screen and (min-height: 1024px) {
  .say-something {
    font-size: 1.25rem;
  }

  .comments-count-icon p {
    font-size: 0.8rem;
    margin-left: 0.2rem;
  }
}
</style>